import React from 'react'

// material ui
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Link from '@mui/material/Link'

// components
import Typography from '@mui/material/Typography'
import { useBrand, useAppSettings } from 'components/shared/SettingsProvider'

const MaxAgeEligibility = props => {
  const { children } = props
  const { marcomUrl } = useBrand()
  const { minAgeFirstDay, maxAgeFirstDay, minAgeMentorship } = useAppSettings()

  return (
    <Card>
      <CardContent>
        {children}
        <Typography paragraph>
          Our programs are designed for children ages {minAgeFirstDay}–
          {maxAgeFirstDay}.{' '}
          <Typography
            component='span'
            fontWeight='fontWeightBold'
            color='error.main'
          >
            Children must be {maxAgeFirstDay} years old on their first day of
            camp,
          </Typography>{' '}
          but may turn {minAgeMentorship} later in the camp season. If you have
          questions about age eligibility, please contact your{' '}
          <Link
            underline='always'
            target='_blank'
            href={`${marcomUrl}/contact/`}
          >
            local team
          </Link>
          .
        </Typography>
      </CardContent>
    </Card>
  )
}

export default MaxAgeEligibility
